import styled from 'styled-components'
import { Content } from 'modals/dialog/s'
import Actions from 'components/form/actions'

export const PickerContent = styled(Content)`
    &:not(.default) {
        height: 704px;

        --__huma-component-modal-content-row: minmax(0, 1fr);
    }
`

export const PickerActions = styled(Actions)`
    margin-block-end: -8px;
    border-top: 1px solid var(--huma-color-border-default);
    padding-block-start: var(--__huma-component-modal-row-gap);
    padding-inline: var(--__huma-component-modal-content-padding);
`